<template>
    <div :id="componentId">
        <div class="my-3">
            <!-- our triggering (target) element -->
            <button :id="reactiveId" style="border: none; outline: none; background: transparent; cursor: pointer" :ref="buttonRef">
                <span :style="textStyle">{{title}}</span>
            </button>
        </div>
        <!-- Our popover title and content render container -->
        <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
        <!-- We specify the same container as the trigger button, so that popover is close to button -->
        <b-popover :target="reactiveId"
                   triggers="focus"
                   :show.sync="popoverShow"
                   placement="right"
                   :container="componentId"
                   :ref="popoverId"
                   @show="onShow"
                   @shown="onShown"
                   @hidden="onHidden">
            <template slot="title">
                <div :ref="focusRefId">Şube Bilgileri</div>
            </template>
            <b-container style="width: 300px">
                <b-row>
                    <b-col style="font-weight: bold;">Şehir:</b-col>
                    <b-col>{{cityCodeToDisplayName(foundSite.cityCode)}}</b-col>
                </b-row>
                <b-row>
                    <b-col style="font-weight: bold;">Bölge:</b-col>
                    <b-col>{{groupIdToDisplayName(foundSite.siteGroupId)}}</b-col>
                </b-row>
                <b-row>
                    <b-col style="font-weight: bold;">Şube Kodu:</b-col>
                    <b-col>{{foundSite.code}}</b-col>
                </b-row>
                <b-row>
                    <b-col style="font-weight: bold;">{{ $t('number of people') }}:</b-col>
                    <b-col>{{foundSite.staffCount}} kişi</b-col>
                </b-row>
                <b-row>
                    <b-col style="font-weight: bold;">Alan:</b-col>
                    <b-col>{{foundSite.area}} m<sup>2</sup></b-col>
                </b-row>
            </b-container>
        </b-popover>
    </div>
</template>

<script>
import _ from 'lodash';
import uuidV4 from 'uuid/v4';
let componentID = uuidV4();
export default {
    props: {
        title: {
            default: () => ''
        },
        textStyle: {
            default: () => null
        },
        siteId: {
            default: () => null
        }
    },
    data() {
        return {
            componentId: `a_${uuidV4()}`,
            reactiveId: `${componentID}_reactive`,
            popoverId: `${componentID}_popover`,
            buttonRef: `${componentID}_button`,
            focusRefId: `${componentID}_focus`,
            popoverShow: false,
            text: null
        };
    },
    watch: {
        title(newVal) {
            this.text = newVal;
        }
    },
    methods: {
        cityCodeToDisplayName(val) {
            let found = _.find(this.$store.state.cities, {code: val});
            if (found) {
                return found.name;
            } else {
                return null;
            }
        },
        groupIdToDisplayName(val) {
            let found = _.find(this.$store.state.siteGroups, {id: val});
            if (found) {
                return found.display_name;
            } else {
                return null;
            }
        },
        onShow() {
            /* This is called just before the popover is shown */
            /* Reset our popover "form" variables */
            this.text = this.title;
        },
        onShown() {
            /* Called just after the popover has been shown */
            /* Transfer focus to the first input */
            /*this.focusRef(this.$refs.input1);*/
        },
        onHidden() {
            /* Called just after the popover has finished hiding */
            /* Bring focus back to the button */
            this.focusRef(this.$refs[this.focusRefId]);
        },
        focusRef(ref) {
            /* Some references may be a component, functional component, or plain element */
            /* This handles that check before focusing, assuming a focus() method exists */
            /* We do this in a double nextTick to ensure components have updated & popover positioned first */
            this.$nextTick(() => {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            });
        }
    },
    computed: {
        foundSite() {
            return _.find(this.sites, {id: Number(this.siteId)});
        }
    }
};
</script>
<style lang="scss" scoped>
</style>

<i18n src="../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/SiteCard.vue